import { render } from "./ReviewsApp.vue?vue&type=template&id=0c9a9a64"
import script from "./ReviewsApp.vue?vue&type=script&lang=js"
export * from "./ReviewsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Spark/components/Product/ReviewsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c9a9a64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c9a9a64', __exports__)) {
    api.reload('0c9a9a64', __exports__)
  }
  
  module.hot.accept("./ReviewsApp.vue?vue&type=template&id=0c9a9a64", () => {
    api.rerender('0c9a9a64', render)
  })

}


export default __exports__